import React from 'react';
import { Outlet } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import Footer from './Footer';
import Navbar from './Navbar';
import { shared } from '../../styles/theme';

function Layout() {
  return (
    <div className={css(styles.page)}>
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

const styles = StyleSheet.create({
  page: shared.page,
});

export default Layout;
